import dark from 'static/map/style/dark.json';
import dark2 from 'static/map/style/dark2.json';
import light from 'static/map/style/light.json';

export default {
  dark,
  dark2,
  light
};
